import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { selectors as i18nSelectors } from 'mage-i18n';

import { Currency } from '@mjolnir/mf-fields-ts/src/enm/Currency';
import { roundPreDecimals } from '@/bpc/utils/math';

type BusinessSizeLabelProps = {
  t: TranslatorFunction;
};

type EnhancedBusinessSizeLabelProps = BusinessSizeLabelProps & {
  to?: number;
  from?: number;
  rate?: number;
  currency?: Currency;
  currencyFormatterFactory: (
    currency: Currency,
    hideDecimals: boolean,
  ) => { format: (number) => string };
};

export const _BusinessSizeLabel: React.FC<EnhancedBusinessSizeLabelProps> = ({
  currencyFormatterFactory,
  currency = Currency.SEK,
  from,
  to,
  rate = 1,
  t,
}: EnhancedBusinessSizeLabelProps): ReactElement | null => {
  const tPrefix = 'products-fe.containers.volume_separation';

  const currencyFormatter = (value: number): string =>
    currencyFormatterFactory(currency, true).format(roundPreDecimals(value * rate, 1));

  if (from && to) {
    return (
      <>
        {t(`${tPrefix}.between`, {
          belowThreshold: currencyFormatter(from),
          aboveThreshold: currencyFormatter(to),
        })}
      </>
    );
  }
  if (from && !to) {
    return (
      <>
        {t(`${tPrefix}.over`, {
          threshold: currencyFormatter(from),
        })}
      </>
    );
  }
  if (!from && to) {
    return (
      <>
        {t(`${tPrefix}.below`, {
          threshold: currencyFormatter(to),
        })}
      </>
    );
  }

  return null;
};

export const BusinessSizeLabel = connect(state => ({
  currencyFormatterFactory: i18nSelectors.formatters.currency(state),
}))(_BusinessSizeLabel);
